(function() {
    'use strict';

    angular.module('process')
        .controller('ProcessStageUpdateController', ProcessStageUpdateController);

    ProcessStageUpdateController.$inject = ['currentProcess', 'row', '$uibModalInstance', 'processStageDataSrvc', 'processStageMessagesConst', 'machineDataSrvc', 'productOptionDataSrvc', 'processStageConjunctionsConst', 'notificationSrvc', 'errorNotificationSrvc'];

    function ProcessStageUpdateController(currentProcess, row, $uibModalInstance, processStageDataSrvc, processStageMessagesConst, machineDataSrvc, productOptionDataSrvc, processStageConjunctionsConst, notificationSrvc, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            machine: [],
            machine_action: [],
            description_pl: [],
            description_en: [],
            description_de: [],
            description_cpde: [],
            description_cpen: [],
            time: [],
            preconditions: [getEmptyPreconditionServerError()]
        };
        self.processStageData = row;

        self.machinesChoices = [];
        self.onMachineSelect = onMachineSelect;

        self.machineActionsChoices = [];

        self.conjunctions = processStageConjunctionsConst;
        self.productOptionsChoices = [];
        self.onProductOptionsSearch = onProductOptionsSearch;
        self.isProductOptionsInPreconditions = isProductOptionsInPreconditions;
        self.isProcessStagePreconditions = isProcessStagePreconditions;
        self.addProcessStagePrecondition = addProcessStagePrecondition;
        self.isNotProcessStagePrecondition = isNotProcessStagePrecondition;
        self.notProcessStagePrecondition = notProcessStagePrecondition;
        self.removeProcessStagePrecondition = removeProcessStagePrecondition;

        self.ok = ok;
        self.cancel = cancel;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getMachinesChoices();
            getProductOptionsChoices();
        }

        function getEmptyPreconditionData() {
            return {
                precondition: undefined,
                conjunction: '',
                is_not: false
            };
        }

        function getEmptyPreconditionServerError() {
            return {
                precondition: [],
                conjunction: [],
                is_not: []
            };
        }

        function getMachinesChoices() {
            return machineDataSrvc.forProcessStage()
                .$promise.then(function(response) {
                    self.machinesChoices = response;

                    var selectedMachine = response.find(function(element, index, array) {
                        return element.pk === self.processStageData.machine;
                    });
                    self.machineActionsChoices = selectedMachine.actions;

                    return response;
                });
        }

        function getProductOptionsChoices() {
            return productOptionDataSrvc.forProcessStage()
                .$promise.then(function(response) {
                    self.productOptionsChoices = response.results;
                    return getSelectedProductOptions();
                });
        }

        function onProductOptionsSearch(params) {
            if (!params) {
                params = {};
            }

            return productOptionDataSrvc.forProcessStage(params).$promise;
        }

        function getSelectedProductOptions() {
            var pks = [];

            self.processStageData.preconditions.forEach(function(precondition) {
                if (precondition.precondition !== undefined && precondition.precondition !== null) {
                    pks.push(precondition.precondition);
                }
            });

            if (!pks.length) {
                return;
            }

            // ui-select resolves the label of a selection out of the options
            // list, and the options behind the already chosen preconditions are
            // not necessarily part of the first page - without fetching them
            // the select would render empty for a saved stage.
            return productOptionDataSrvc.forProcessStage({
                pks: pks.join(','),
                page_size: pks.length
            }).$promise.then(function(response) {
                var loaded = self.productOptionsChoices.map(function(option) {
                    return option.pk;
                });

                response.results.forEach(function(option) {
                    if (loaded.indexOf(option.pk) === -1) {
                        self.productOptionsChoices.push(option);
                    }
                });

                return response;
            });
        }

        function onMachineSelect(pk) {
            for (var i=0; i<self.machinesChoices.length; i++) {
                if (self.machinesChoices[i].pk === pk) {
                    self.cleanErrors('machine');
                    self.processStageData.machine_action = undefined;
                    self.machineActionsChoices = self.machinesChoices[i].actions;
                    break;
                }
            }
        }

        function isProductOptionsInPreconditions(currentIndex, item) {
            var tmp = self.processStageData.preconditions.filter(
                function(element, index, array) {
                    return element.precondition === item.pk && array[currentIndex].precondition !== item.pk;
                }
            );

            return !tmp.length;
        }

        function isProcessStagePreconditions() {
            return self.processStageData.preconditions.length;
        }

        function addProcessStagePrecondition() {
            self.processStageData.preconditions.push(
                getEmptyPreconditionData());
        }

        function removeProcessStagePrecondition(index) {
            if (self.processStageData.preconditions.length > 1 && index === self.processStageData.preconditions.length - 1) {
                self.processStageData.preconditions[
                    self.processStageData.preconditions.length - 2].conjunction = undefined;
            }

            self.processStageData.preconditions.splice(index, 1);
        }

        function isNotProcessStagePrecondition(index) {
            return self.processStageData.preconditions[index].is_not;
        }

        function notProcessStagePrecondition(index) {
            self.processStageData.preconditions[index].is_not = !self.processStageData.preconditions[index].is_not;
        }

        function ok() {
            processStageDataSrvc.update(
                self.processStageData
            ).$promise.then(
                function(response) {
                    $uibModalInstance.close(response);
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
